<div style="display: flex; align-items: center" class="customChips">
    <!-- <button mat-icon-button [matMenuTriggerFor]="menu" color="primary" (click)="$event.stopPropagation()">
        <mat-icon>add_box</mat-icon>
    </button> -->
    <span *ngIf="showAddLabel">
        College(s)
    </span>
    <button mat-icon-button color="primary" *ngIf="allowEdit" (click)="select.open(); control.markAsTouched()">
        <mat-icon>add_box</mat-icon>
        <mat-select #select 
            class="collegeSelect"
            placeholder="Colleges" 
            [formControl]="control" 
            [compareWith]="compareFn" 
            multiple
        >
            <mat-option *ngFor="let opt of options;" [value]="opt" (onSelectionChange)="UpdateTag($event)" > <!-- [disabled]="!opt.active" -->
                {{ opt.name }}
            </mat-option>
        </mat-select>
    </button>


    <mat-chip-list class="mat-chip-list-stacked" [class.isVertical]="isVertical" [aria-orientation]="isVertical ? 'vertical' : 'horizontal'">
        <mat-chip 
            *ngFor="let val of control.value"
            [class]="cssClass(val.name)"
            (removed)="onTagRemoved(val)"
            [disabled]="!val.active"
            color="primary"
            [matTooltip]="!val.active ? 'This college is not currently active in the system, and cannot be removed.' : ''" 
            matTooltipPosition="below"
        >
            {{ val.name }}
            <!-- <span style="flex-grow: 1"></span> -->
            <mat-icon matChipRemove class="removeBtn" *ngIf="val.active && canRemove">cancel</mat-icon>
        </mat-chip>
    </mat-chip-list>

    <!-- <mat-menu #menu="matMenu">
        <mat-selection-list
            #tagList
            [(ngModel)]="selectedTagIDs"
            (click)="$event.stopPropagation()"
            (selectionChange)="updateTags($event)"
        >
            <mat-list-option *ngFor="let opt of options;" [value]="opt.id">
                {{ opt.name }}
            </mat-list-option>
        </mat-selection-list>
    </mat-menu> -->
</div>



// WEBPACK FOOTER //
// ./src/app/ui/tags/tags.component.html